/**
 * „Früheste Lieferung" aus dem Hersteller-Katalog liegt als „KW.Jahr" vor
 * (z. B. "30.2026"). Diese Util rechnet das in ein konkretes Kalenderdatum
 * (Montag der ISO-Kalenderwoche) um und formatiert es deutsch.
 */

/** Montag der ISO-KW als Date (UTC), oder null bei ungültiger Eingabe. */
export function isoWeekMonday(week, year) {
    if (!week || !year) return null;
    // 4. Januar liegt immer in KW 1 (ISO 8601)
    const jan4 = new Date(Date.UTC(year, 0, 4));
    const jan4Dow = jan4.getUTCDay() || 7; // So=7
    const week1Monday = new Date(jan4);
    week1Monday.setUTCDate(jan4.getUTCDate() - (jan4Dow - 1));
    const monday = new Date(week1Monday);
    monday.setUTCDate(week1Monday.getUTCDate() + (week - 1) * 7);
    return monday;
}

/** "30.2026" -> "20.07.2026 (KW 30)". Leerer String bei ungültiger Eingabe. */
export function formatDeliveryWeek(kwStr) {
    const m = /^(\d{1,2})\.(\d{4})$/.exec(String(kwStr || "").trim());
    if (!m) return "";
    const week = Number(m[1]);
    const year = Number(m[2]);
    const d = isoWeekMonday(week, year);
    if (!d) return `KW ${week}/${year}`;
    const dd = String(d.getUTCDate()).padStart(2, "0");
    const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
    return `${dd}.${mm}.${d.getUTCFullYear()} (KW ${week})`;
}

/** Sortierschlüssel (Jahr*100+KW); ungültige/leere ans Ende. */
export function deliverySortKey(kwStr) {
    const m = /^(\d{1,2})\.(\d{4})$/.exec(String(kwStr || "").trim());
    if (!m) return Number.MAX_SAFE_INTEGER;
    return Number(m[2]) * 100 + Number(m[1]);
}
